import { FormikProps, useFormik } from "formik";
import { SignInFormProps } from "../types/forget-password-types";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { signIn } from "../../../screens/auth/authSlice";
import { RootState, useAppDispatch } from "../../../store"; // Custom hook for typed dispatch
import { toast } from "react-toastify";
import { useState } from "react";
import { useSelector } from "react-redux";

const useForgotPassword = () => {
  const navigate = useNavigate();


  const formik: FormikProps<SignInFormProps> = useFormik<SignInFormProps>({
    initialValues: {
      loginInput: "",
       password: "",
      confirmPassword: "",
      userType: "merchant",
    },
    validationSchema: Yup.object().shape({
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Required"),
    }),
    async onSubmit() {
      
    },
  });

  return { formik };
};

export default useForgotPassword;
